var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}add-sqr`,"viewBox":"0 0 20 20"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 0C2.68629 0 0 2.68629 0 6V14C0 17.3137 2.68629 20 6 20H14C17.3137 20 20 17.3137 20 14V6C20 2.68629 17.3137 0 14 0H6ZM9 5H11V9H15V11H11V15H9V11H5V9H9V5Z","fill":_vm.getColor('main')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }